import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface IErrorModalParameters {
  error: Error;
}
@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
})
export class ErrorModalComponent {
  public parameters: IErrorModalParameters;

  constructor(private _activeModal: NgbActiveModal) {
    // @ts-expect-error - default parameters
    this.parameters = { error: null };
  }

  public get error(): Error {
    return this.parameters.error;
  }

  public dismiss(): void {
    this._activeModal.dismiss();
  }
}
